// extracted by mini-css-extract-plugin
module.exports = {"ArrowType2SVG":"ArrowType2SVG-module__ArrowType2SVG"};